<template>
    <div class="home text-center">
        <apexchart v-if="data.series !== undefined"
            ref="chart"
            :height="'100%'"
            :type="type ? type: 'bar'"
            :options="options"
            :series="data.series"
        ></apexchart>

        <p v-else>Loanding ...</p>
        
        <v-btn v-if="!hideArrows" @click="$emit('before')" fab dark x-small color="white primary--text" class="mr-3">
            <v-icon dark>mdi-chevron-left</v-icon>
        </v-btn>
        {{ description }}
        <v-btn v-if="!hideArrows" @click="$emit('next')" fab dark x-small color="white primary--text" class="ml-3">
            <v-icon dark>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'Home',
    props: ['data', 'type', 'freq', 'hideArrows'],
    data() {
        return {
            months: [
                'En',
                'Feb',
                'Mar',
                'Abr',
                'May',
                'Jun',
                'Jul',
                'Ago',
                'Sept',
                'Oct',
                'Nov',
                'Dic'
            ],
            options: {
                colors: ['#008ffb', '#00e396', '#feb019'],
                chart: {
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                yaxis: {
                    title: {
                        text: 'Kwh',
                    }
                },
                xaxis: {
                    categories: [],
                },
                dataLabels: {
                    enabled: false
                },
            },
            description: ''
        }
    },
    methods: {
        updateOptions(){
            this.setYaxis()
            this.setCategories()
            this.setColors()
            this.$refs.chart.updateOptions(this.options)
        },
        setYaxis(){
            const max_array = this.data.series.map( serie => Math.max( ...serie.data.filter( data => !isNaN(data) ) ) )
            let max_val = Math.max(...max_array)
            max_val = parseInt(max_val + 1)

            const min_array = this.data.series.map( serie => Math.min( ...serie.data.filter( data => !isNaN(data) ) ) )
            let min_val = Math.min(...min_array)
            min_val = min_val === 0 ? 0 : parseInt(min_val - 1)

            const diff = max_val - min_val
            if(diff <= 20) {
                this.options.yaxis.max = (parseInt(max_val/5) + 2) * 5
                this.options.yaxis.min = min_val === 0 ? 0 : (parseInt(min_val/5) - 1) * 5
                this.options.yaxis.tickAmount = (this.options.yaxis.max - this.options.yaxis.min) /5
            }
            else if(diff <= 200){
                this.options.yaxis.max = (parseInt(max_val/10) + 1) * 10
                this.options.yaxis.min = min_val === 0 ? 0 : (parseInt(min_val/10) - 1) * 10
                this.options.yaxis.tickAmount = (this.options.yaxis.max - this.options.yaxis.min) / 10
            }else{
                this.options.yaxis.max = (parseInt(max_val/200) + 1) * 200
                this.options.yaxis.min = min_val === 0 ? 0 : (parseInt(min_val/200) - 1) * 200
                this.options.yaxis.tickAmount = (this.options.yaxis.max - this.options.yaxis.min) / 200
            }
        },
        setCategories(){
            if(this.data.categories.length == 0) return
            this.options.xaxis.categories = this.data.categories.map( c => {
                if(this.freq === 'hour') 
                    return `${c.getHours()}` 
                if(this.freq === 'day') 
                    return `${c.getDate()} ${this.months[c.getMonth()]}` 
                if(this.freq === 'month') 
                    return `${this.months[c.getMonth()]}` 
            })
        },
        setColors(){
            const colors = {
                'Consumo': '#feb019',
                'Neto': '#008ffb',
                'Generación': '#00e396'
            }
            this.data.series.forEach((serie, index) => {
                this.options.colors[index] = colors[serie.name]
            });
        },
        setDescriptionDate(){
            if(this.freq === 'hour') 
                this.description = `${ this.data.categories[0].toLocaleDateString() }` 
            if(this.freq === 'day') 
                this.description = `${this.data.categories[0].toLocaleDateString()} - ${this.data.categories[this.data.categories.length - 1].toLocaleDateString()}` 
            if(this.freq === 'month') 
                this.description = `${this.data.categories[0].getFullYear()}` 
        }
    },
    watch: {
        'data.series'(){
            this.updateOptions()
            this.setDescriptionDate()
        }
    },
    mounted(){
        this.updateOptions()
        this.setDescriptionDate()
    }
};
</script>
<style scoped>
.home {
    height: 100%;
    width: 100%;
}
</style>
